import { useRef, useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = forwardRef(({ onChange }, ref) => {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const c = canvas.current;
    const setup = () => {
      const ratio = window.devicePixelRatio || 1;
      c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
      const ctx = c.getContext("2d");
      ctx.scale(ratio, ratio); ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0f172a";
      setEmpty(true); onChangeRef.current?.(false);
    };
    setup();
    let w = c.offsetWidth;
    const ro = new ResizeObserver(() => { if (c.offsetWidth !== w) { w = c.offsetWidth; setup(); } });
    ro.observe(c);
    return () => ro.disconnect();
  }, []);

  const pos = (e) => { const r = canvas.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); canvas.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = canvas.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = canvas.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); if (empty) { setEmpty(false); onChange?.(true); } };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = canvas.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange?.(false); };
  useImperativeHandle(ref, () => ({ toDataURL: () => (empty ? "" : canvas.current.toDataURL("image/png")), clear }));

  return (
    <div className="relative">
      <canvas ref={canvas} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-36 bg-white border-2 border-dashed border-slate-300 rounded-lg touch-none cursor-crosshair" data-testid="signature-pad" />
      {empty && <p className="absolute inset-0 flex items-center justify-center text-sm text-slate-300 pointer-events-none">Sign here with your finger or mouse</p>}
      <div className="absolute left-4 right-4 bottom-7 border-b border-slate-200 pointer-events-none" />
      <button type="button" onClick={clear} className="absolute top-2 right-2 text-xs text-slate-400 hover:text-slate-700 flex items-center gap-1" data-testid="signature-clear"><Eraser className="w-3.5 h-3.5" />Clear</button>
    </div>
  );
});
SignaturePad.displayName = "SignaturePad";
